var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"If you’ve had sex without a condom already, there’s no point in continuing to use condoms.","answer":false}})}
var staticRenderFns = []

export { render, staticRenderFns }